import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm4.495 5.505a.7.7 0 0 0-.99 0L12 11.011 8.495 7.505a.7.7 0 0 0-.99 0l-.074.087a.7.7 0 0 0 .074.903L11.011 12l-3.506 3.505a.7.7 0 0 0 0 .99l.087.074a.7.7 0 0 0 .903-.074L12 12.988l3.505 3.507a.7.7 0 0 0 .99 0l.074-.087a.7.7 0 0 0-.074-.903L12.988 12l3.507-3.505a.7.7 0 0 0 0-.99z"
            fill="#706F6F"
            fillRule="evenodd"
        />
    </svg>
);
